import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, DoubleArrow, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../../components/FormikControl/FormikControl';
import voucherServices from '../voucherServices';
import { useAlert } from '../../../../../../context/AlertContext';
import { useAppData } from '../../../../../../context/AppDataContext';
import moment from 'moment';
import SelectParty from '../../party/components/SelectParty';
import { useNavigate } from 'react-router-dom';
import { useKeyPress } from '../../../../../../hooks/useKeyPress';



function PaymentReceiptVoucherForm({data,callBack,voucherType }) {

    const {AppAlert} = useAlert();
    const {userDD,  getDDDataById,masters,ledgerDD} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);


    const [party,setParty] = useState(null);
    const [draftList,setDraftList] = useState(null);

    const [showForm,setShowFormStatus] = useState(false);

    const bankCashLedgers = ledgerDD.filter(l => 
        ['Bank Accounts', 'Cash-in-Hand', 'Bank OCC A/c', 'Bank OD A/c'].includes(l.groupTitle)
    );

    const initialValues = {
        voucherType:voucherType,        
        voucherDate:moment().format(moment.HTML5_FMT.DATE),

        paymentLedgerId:"",
        grandTotal:"",
        instrumentNo:"",
        instrumentDate:moment().format(moment.HTML5_FMT.DATE),
        narration:"",
        //declaration:"We declare that this invoice shows the actual price of the goods / services described and that all particulars are true and correct.",
        //terms:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            voucherType:voucherType,    
            voucherDate:data.voucherDate?data.voucherDate:moment().format(moment.HTML5_FMT.DATE),

            paymentLedgerId:data.paymentLedgerId,
            grandTotal:data.grandTotal,
            instrumentNo:data.instrumentNo,
            instrumentDate:data.instrumentDate?data.instrumentDate:moment().format(moment.HTML5_FMT.DATE),
            narration:data.narration,
            //declaration:data.declaration?data.declaration:"We declare that this invoice shows the actual price of the goods / services described and that all particulars are true and correct.",
            //terms:data.terms,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        //partyId:Yup.string().required("Required"),
        //voucherNo:Yup.string().required("Required"),
        voucherDate:Yup.string().required("Required"),
        paymentLedgerId:Yup.string().required("Required"),
        grandTotal:Yup.number().moreThan(0, 'Amount can not be zero').required("Required"),
        //instrumentNo:Yup.string().required("Required"),
        
        //declaration:Yup.string().required("Required"),
        //terms:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const navigate = useNavigate();

    const getDraftList = () =>{
        let payload = {
            voucherType:voucherType,
            ledgerId:party.ledgerId,
        }
        setSavingStatus(true);
        setDraftList(null);
        voucherServices.getDraftList(payload).then(res=>{
           setDraftList(res.data);
           if(res.data.length == 0 ){
            setShowFormStatus(true);
           } else{
            setShowFormStatus(false);
           }
        }).catch(error=>{
            console.log(error)
        }).finally(()=>{
            setSavingStatus(false);
        })
    }
    const onSubmit = (values, onSubmitProps) => {
        let payload = {...values};

        if(party){
            payload.partyId = party.id;
            payload.ledgerId = party.ledgerId;
            payload.billingAddressId = null;
            payload.shippingAddressId = null;
            if(party.taxDetails){
                payload.partyGstin = party.taxDetails.gstin;
                payload.partyPan = party.taxDetails.panNo;
                payload.registrationType = party.taxDetails.registrationType;
                payload.tdsApplicable = party.taxDetails.tdsApplicable;
            }
        } else {
            AppAlert("No Party Selected","error");
            return false;
        }
        voucherServices.save(payload).then(res=>{
            AppAlert(res.msg);
            if(!data){
                navigate("/voucher/payment-receipt/details/"+res.id)
            }
            setDialogStatus(false);
            if(callBack){
                callBack();
            }
        }).catch(error=>{
            console.log(error);
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    useKeyPress('F5', addNew, { condition: voucherType === 'Payment' }, [voucherType]);
    useKeyPress('F6', addNew, { condition: voucherType === 'Receipt' }, [voucherType]);


    useEffect(()=>{
        setDraftList(null);
        if(party){
            getDraftList();
        }
    },[party])
    
    return (
        <>
            {!data &&
                <Tooltip title={`Add New ${voucherType} Voucher (${voucherType === 'Payment' ? 'Fn + F5' : 'Fn + F6'})`}>
                    <button type="button" className='btn btn-default w-100 text-start' onClick={addNew}>
                        <Add/> {voucherType} Voucher 
                        <span style={{ fontSize: '0.85em', opacity: 0.7, marginLeft: '8px' }}>
                            ({voucherType === 'Payment' ? 'F5' : 'F6'})
                        </span>
                    </button>
                </Tooltip>
            }
            {data &&
                <button className="btn btn-outline-primary me-2" onClick={updateData}>
                    Edit {voucherType} Voucher
                </button>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{voucherType} Voucher</DialogTitle>

                                    <DialogContent>
                                            <div className="row bg-light-primary">

                                                <div className='col-md-8 my-2'>
                                                    {dialogStatus &&
                                                        <SelectParty party={party} setParty={setParty} partyRole={ voucherType=="Receipt"? {value:1} : {value:2}} partyId={data? data.partyId : null} /> 
                                                    }
                                                </div>

                                                {data &&
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Voucher Date" name="voucherDate" 
                                                    />
                                                </div>
                                                }

                                            </div>
                                            
                                            {party && !showForm &&  draftList?.length > 0 &&
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className='row'>
                                                            <div className='col-md-12'>
                                                                <p className='text-muted small mb-0'>We found existing vouchers for this party. Choose one to view details or create a new one.</p>
                                                            </div>

                                                            <div className='col-md-12'>
                                                                <div className="table-responsive shadow-sm rounded">
                                                                    <table className="table table-hover align-middle bg-white mb-0">
                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                <th scope="col" className="py-3">Created</th>
                                                                                <th scope="col" className="py-3">Updated</th>
                                                                                <th scope="col" className="py-3">Created By</th>
                                                                                <th scope="col" className="py-3">Total Amount</th>
                                                                                <th scope="col" className="py-3 text-end">Actions</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {draftList.map(voucher => (
                                                                                <tr key={voucher.id}>
                                                                                    {/* Created Date */}
                                                                                    <td>
                                                                                        <span className="small text-secondary">
                                                                                            {moment(voucher.created_at).format("lll")}
                                                                                        </span>
                                                                                    </td>
                                                                                    {/* Updated Date */}
                                                                                    <td>
                                                                                        <span className="small text-secondary">
                                                                                            {moment(voucher.updated_at).format("lll")}
                                                                                        </span>
                                                                                    </td>
                                                                                    {/* User / Created By */}
                                                                                    <td>
                                                                                        <span className="fw-semibold text-dark">
                                                                                            {getDDDataById(userDD, voucher.userId)?.label || 'N/A'}
                                                                                        </span>
                                                                                    </td>
                                                                                    {/* Grand Total */}
                                                                                    
                                                                                    <td>
                                                                                        <span className="fw-bold text-success">
                                                                                            {voucher.grandTotal}
                                                                                        </span>
                                                                                    </td>
                                                                                    
                                                                                    {/* Action Button */}
                                                                                    <td className="text-end">
                                                                                        <button 
                                                                                            className="btn btn-outline-primary btn-sm d-inline-flex align-items-center gap-1 px-3 shadow-sm" 
                                                                                            type="button"  
                                                                                            onClick={() => {
                                                                                                navigate("/voucher/sale-purchase/details/" + voucher.id);
                                                                                                setDialogStatus(false);
                                                                                            }}
                                                                                        >
                                                                                            <span>View</span>
                                                                                            <DoubleArrow />
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-12 mt-2'>
                                                        <button className='btn btn-primary float-end' type='button' onClick={()=>setShowFormStatus(true)}><Add/> Create New</button>
                                                    </div>
                                                </div>
                                            }

                                            {party && showForm &&
                                            <div className='row'>
                                                <hr />
                                                <div className='col-md-6 my-2'>
                                                    <FormikControl control="autoselect" formik={formik}  autoFocus
                                                        label={voucherType === 'Payment' ? "Pay From (Bank/Cash)" : "Deposit To (Bank/Cash)"}
                                                        name="paymentLedgerId"  
                                                        options={bankCashLedgers} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number" 
                                                        label="Total Amount" name="grandTotal" 
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2 mb-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Instrument No" name="instrumentNo" 
                                                    />
                                                </div>


                                                <div className="col-md-6 my-2 mb-4" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Instrument Date" name="instrumentDate" 
                                                    />
                                                </div>

                                                <hr/>
                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Narration" name="narration"   
                                                    />
                                                </div>

                                                <div className='col-md-12'>
                                                    {savingInProgress ?
                                                        <LinearProgress/>
                                                        :
                                                        <>
                                                            <button className="btn btn-primary float-end" type="submit">Save</button>
                                                            <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                        </>
                                                    }
                                                </div>
                                                <div className='col-md-12'>
                                                    { /* JSON.stringify(formik)  */}
                                                </div>
                                            </div>

                                            
                                        }
                                        <div className="row mt-3">
                                            
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default PaymentReceiptVoucherForm